import { Input, Select } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import { useMerchant } from "../../context/merchantContext";

const SearchMerchant = ({
  title,
  fieldName,
  select,
  width = 200,
  noSearch = false,
  sort = true,
}) => {
  const { searchFieldsInvoice, setSearchFieldsInvoice, showFilter } =
    useMerchant();

  const valueChange = (e) => {
    const currValue = e.target.value;
    setSearchFieldsInvoice((e) => {
      return { ...e, [fieldName]: currValue || null };
    });
  };
  const selectChange = (value) => {
    setSearchFieldsInvoice((e) => {
      return { ...e, [fieldName]: value || null };
    });
  };
  const sortChange = (sort) => {
    setSearchFieldsInvoice({
      ...searchFieldsInvoice,
      sort: sort,
      sortField: fieldName,
    });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort flex items-center justify-between">
        <span style={{ fontSize: 12 }}>{title}</span>
        {sort && (
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        )}
      </div>
      {showFilter && (
        <>
          <div className="line" />
          {noSearch ? (
            <div style={{ height: 25 }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {select ? (
                <Select
                  size="small"
                  value={searchFieldsInvoice[fieldName] || null}
                  style={{ width: width }}
                  onChange={selectChange}
                >
                  {select.map((e, i) => {
                    return (
                      <Select.Option
                        style={{ width: "80%" }}
                        key={i}
                        value={e.value}
                      >
                        {e.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              ) : (
                <Input
                  size="small"
                  style={{ width: "80%" }}
                  placeholder="Хайх утга"
                  value={searchFieldsInvoice[fieldName]}
                  onChange={valueChange}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default SearchMerchant;
